import * as yup from "yup";
import { useMutation } from "@tanstack/react-query";
import moment from "moment";
import { API_DATE_FORMAT, HTTP_ENDPOINTS } from "../../consts/api";
import { http } from "../../services/HttpService";
import { passOr, removeNullishFromShape } from "../../utilities/general";

const requestSchema = yup.object({
  productId: yup.number().required(),
  pageSize: yup.number().required(),
  page: yup.number().default(1),
  dateFrom: yup.date().nullable(),
  dateTo: yup.date().nullable(),
  clinicIds: yup.array().of(yup.number()).required(),
  allClinics: yup.boolean().required(),
});

const responseSchema = yup.object({
  fileName: yup.string().required(),
});

const composeResponse = (res) => {
  return {
    fileName: res?.data?.data?.file,
  };
};

export function useDownloadProductDetailedLogsMutation(options) {
  return useMutation(async (payload) => {
    const req = requestSchema.validateSync(payload, {
      strict: true,
    });

    const fromDate = passOr(req.dateFrom, null, () =>
      moment(req.dateFrom).format(API_DATE_FORMAT),
    );

    const toDate = passOr(req.dateTo, null, () =>
      moment(req.dateTo).format(API_DATE_FORMAT),
    );

    const res = await http.get(HTTP_ENDPOINTS.downloadProductDetailedLogs(), {
      params: removeNullishFromShape({
        id: req.productId,
        page: req.page,
        pagesize: req.pageSize,
        fromDate,
        toDate,
        clinic_id: req.clinicIds,
        all_clinics: req.allClinics,
        export: true,
      }),
    });

    return responseSchema.validateSync(composeResponse(res, req), {
      strict: true,
    });
  }, options);
}
